export enum UserRole {
  USER = "ROLE_USER",
  ADMIN = "ROLE_ADMIN",
  MANAGER = "ROLE_MANAGER",
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  roles: string[]; // I'm not sure if this field is used anywhere. On the back end, User is an array. In the DTO its a single field.
  role?: UserRole;
  status?: "PENDING_APPROVAL" | "ACTIVE" | "INACTIVE" | "TERMINATED";
  seniorityLevelId?: string;
  eligiblePositionIds?: string[];
  taxDocumentsSigned?: boolean;
  positionDocuments?: PositionDocument[];
  emailNotifications?: boolean;
  smsNotifications?: boolean;
  bilingual?: boolean;
  howDidYouHearAboutUs?: string;
  shirtSize?: string;
  receivedShirt?: boolean;
  badgeReceived?: boolean;
  userNotes?: string;
  city?: string;
  referredById?: string | null;
  referredByName?: string | null;
}

export interface PositionDocument {
  positionId: string;
  positionName: string;
  documentSigned: boolean;
}

export interface AuthState {
  token: string | null;
  user: User | null;
  loading: boolean; // Add loading state
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => void;
}

export interface AuthResponse {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  accessToken: string;
  tokenType: string;
  phoneNumber: string;
  seniorityLevelId?: string;
  taxDocumentsSigned?: boolean;
  eligiblePositionIds?: string[];
  eligiblePositionNames?: string[];
  positionDocuments?: PositionDocument[];
  notificationPreferences?: {
    textMessages: boolean;
    email: boolean;
  };
}
